import { render, staticRenderFns } from "./SPIFCashRatiosVariance.vue?vue&type=template&id=325d72a0"
import script from "./SPIFCashRatiosVariance.vue?vue&type=script&lang=js"
export * from "./SPIFCashRatiosVariance.vue?vue&type=script&lang=js"
import style0 from "./SPIFCashRatiosVariance.vue?vue&type=style&index=0&id=325d72a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports